module.exports = __webpack_public_path__ + "static/img/39.9fdda1d1.png";